import {Routes} from '@angular/router';
import {authGuard} from './Core/Guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'onboarding',
    pathMatch: 'full'
  },
  {
    path: 'onboarding',
    loadComponent: () => import('./Pages/Auth/onboarding/onboarding.page').then(m => m.OnboardingPage)
  },
  {
    path: 'app',
    canActivate: [authGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./Pages/Core/tabs/tabs.routes').then(m => m.TABS_ROUTES),
      },
      {
        path: 'notifications',
        loadComponent: () => import('./Pages/Notifications/notifications-list/notifications-list.page').then(m => m.NotificationsListPage)
      },
      {
        path: 'modules-items',
        loadComponent: () => import('./Pages/Modules/modules-items/modules-items.page').then(m => m.ModulesItemsPage)
      },
      {
        path: 'modules-store',
        loadComponent: () => import('./Pages/Modules/modules-store/modules-store.page').then(m => m.ModulesStorePage)
      },
      {
        path: 'edit-password',
        loadComponent: () => import('./Pages/Configuration/edit-password/edit-password.page').then(m => m.EditPasswordPage)
      },
      {
        path: 'edit-profile',
        loadComponent: () => import('./Pages/Configuration/edit-profile/edit-profile.page').then(m => m.EditProfilePage)
      },
      {
        path: 'edit-pin',
        loadComponent: () => import('./Pages/Configuration/edit-pin/edit-pin.page').then(m => m.EditPinPage)
      },
      {
        path: 'notifications-config',
        loadComponent: () => import('./Pages/Configuration/notifications-config/notifications-config.page').then(m => m.NotificationsConfigPage)
      },
      {
        path: 'devices-store',
        loadComponent: () => import('./Pages/Configuration/devices/devices-store/devices-store.page').then(m => m.DevicesStorePage)
      },
      {
        path: 'users-store',
        loadComponent: () => import('./Pages/Configuration/users/users-store/users-store.page').then(m => m.UsersStorePage)
      },
      {
        path: 'users/:id',
        loadComponent: () => import('./Pages/Configuration/users/user-detail/user-detail.page').then(m => m.UserDetailPage)
      },
      {
        path: 'file-store',
        loadComponent: () => import('./Pages/Rrhh/Folders/file-store/file-store.page').then(m => m.FileStorePage)
      },
      {
        path: 'file-info',
        loadComponent: () => import('./Pages/Rrhh/Folders/file-info/file-info.page').then(m => m.FileInfoPage)
      },
      {
        path: 'gallery',
        loadComponent: () => import('./Pages/Shared/gallery/gallery.page').then(m => m.GalleryPage)
      },
      {
        path: 'holiday-store',
        loadComponent: () => import('./Pages/Rrhh/Holidays/holidays-store/holidays-store.page').then(m => m.HolidaysStorePage)
      },
      {
        path: 'requests-store',
        loadComponent: () => import('./Pages/Rrhh/Requests/requests-store/requests-store.page').then(m => m.RequestsStorePage)
      },
      {
        path: 'clock-in-store',
        loadComponent: () => import('./Pages/Rrhh/Clock-in/clock-in-store/clock-in-store.page').then(m => m.ClockInStorePage)
      },
      {
        path: 'schedule-store',
        loadComponent: () => import('./Pages/Rrhh/Schedules/schedule-store/schedule-store.page').then(m => m.ScheduleStorePage)
      },
      {
        path: 'product/:id',
        loadComponent: () => import('./Pages/Purchases/Products/product-detail/product-detail.page').then(m => m.ProductDetailPage)
      },
      {
        path: 'product-store',
        loadComponent: () => import('./Pages/Purchases/Products/product-store/product-store.page').then(m => m.ProductStorePage)
      },
      {
        path: 'product-provider-store',
        loadComponent: () => import('./Pages/Purchases/Products/product-provider-store/product-provider-store.page').then(m => m.ProductProviderStorePage)
      },
      {
        path: 'provider/:id',
        loadComponent: () => import('./Pages/Purchases/Providers/provider-detail/provider-detail.page').then(m => m.ProviderDetailPage)
      },
      {
        path: 'provider-store',
        loadComponent: () => import('./Pages/Purchases/Providers/provider-store/provider-store.page').then(m => m.ProviderStorePage)
      },
      {
        path: 'provider-contact-store',
        loadComponent: () => import('./Pages/Purchases/Providers/provider-contact-store/provider-contact-store.page').then(m => m.ProviderContactStorePage)
      },
      {
        path: 'provider-product-store',
        loadComponent: () => import('./Pages/Purchases/Providers/provider-product-store/provider-product-store.page').then(m => m.ProviderProductStorePage)
      },
      {
        path: 'order/:id',
        loadComponent: () => import('./Pages/Purchases/Orders/order-detail/order-detail.page').then(m => m.OrderDetailPage)
      },
      {
        path: 'order-store',
        loadComponent: () => import('./Pages/Purchases/Orders/order-store/order-store.page').then(m => m.OrderStorePage)
      },
      {
        path: 'delivery-note/:id',
        loadComponent: () => import('./Pages/Purchases/Delivery-notes/delivery-note-detail/delivery-note-detail.page').then(m => m.DeliveryNoteDetailPage)
      },
      {
        path: 'delivery-note-store',
        loadComponent: () => import('./Pages/Purchases/Delivery-notes/delivery-note-store/delivery-note-store.page').then(m => m.DeliveryNoteStorePage)
      },
      {
        path: 'cash-closing/:id',
        loadComponent: () => import('./Pages/Finances/Cash-closing/cash-closing-detail/cash-closing-detail.page').then(m => m.CashClosingDetailPage)
      },
      {
        path: 'cash-closing-store',
        loadComponent: () => import('./Pages/Finances/Cash-closing/cash-closing-store/cash-closing-store.page').then(m => m.CashClosingStorePage)
      },
      {
        path: 'ebitda-detail',
        loadComponent: () => import('./Pages/Finances/Ebitda/ebitda-detail/ebitda-detail.page').then(m => m.EbitdaDetailPage)
      },
      {
        path: 'ebitda-report-options',
        loadComponent: () => import('./Pages/Finances/Ebitda/ebitda-report-options/ebitda-report-options.page').then(m => m.EbitdaReportOptionsPage)
      },
      {
        path: 'personal-payments-store',
        loadComponent: () => import('./Pages/Finances/Cash-closing/personal-payments-store/personal-payments-store.page').then(m => m.PersonalPaymentsStorePage)
      },
      {
        path: 'income-store',
        loadComponent: () => import('./Pages/Finances/Cash-closing/income-store/income-store.page').then(m => m.IncomeStorePage)
      },
      {
        path: 'purchase-payments-store',
        loadComponent: () => import('./Pages/Finances/Cash-closing/purchase-payments-store/purchase-payments-store.page').then(m => m.PurchasePaymentsStorePage)
      },
      {
        path: 'general-expenses-store',
        loadComponent: () => import('./Pages/Finances/Expenses/general-expenses-store/general-expenses-store.page').then(m => m.GeneralExpensesStorePage)
      },
      {
        path: 'personal-expenses-store',
        loadComponent: () => import('./Pages/Finances/Expenses/personal-expenses-store/personal-expenses-store.page').then(m => m.PersonalExpensesStorePage)
      },
      {
        path: 'expenses-options',
        loadComponent: () => import('./Pages/Finances/Expenses/expenses-options/expenses-options.page').then(m => m.ExpensesOptionsPage)
      },
      {
        path: 'expense-detail',
        loadComponent: () => import('./Pages/Finances/Expenses/expense-detail/expense-detail.page').then(m => m.ExpenseDetailPage)
      },
      {
        path: 'elaboration/:id',
        loadComponent: () => import('./Pages/YuChef/Elaborations/elaboration-detail/elaboration-detail.page').then(m => m.ElaborationDetailPage)
      },
      {
        path: 'elaboration-store',
        loadComponent: () => import('./Pages/YuChef/Elaborations/elaboration-store/elaboration-store.page').then(m => m.ElaborationStorePage)
      },
      {
        path: 'elaboration-step-store',
        loadComponent: () => import('./Pages/YuChef/Elaborations/elaboration-step-store/elaboration-step-store.page').then(m => m.ElaborationStepStorePage)
      },
      {
        path: 'recipe-costing/:id',
        loadComponent: () => import('./Pages/YuChef/Recipes-costing/recipe-costing-detail/recipe-costing-detail.page').then(m => m.RecipeCostingDetailPage)
      },
      {
        path: 'recipe-costing-store',
        loadComponent: () => import('./Pages/YuChef/Recipes-costing/recipe-costing-store/recipe-costing-store.page').then(m => m.RecipeCostingStorePage)
      },
      {
        path: 'recipe-costing-ingredient-store',
        loadComponent: () => import('./Pages/YuChef/Recipes-costing/recipe-costing-ingredient-store/recipe-costing-ingredient-store.page').then(m => m.RecipeCostingIngredientStorePage)
      },
      {
        path: 'recipe-costing-step-store',
        loadComponent: () => import('./Pages/YuChef/Recipes-costing/recipe-costing-step-store/recipe-costing-step-store.page').then(m => m.RecipeCostingStepStorePage)
      },
      {
        path: 'recipe/:id',
        loadComponent: () => import('./Pages/YuChef/Recipes/recipes-detail/recipes-detail.page').then(m => m.RecipesDetailPage)
      },
      {
        path: 'recipe-store',
        loadComponent: () => import('./Pages/YuChef/Recipes/recipe-store/recipe-store.page').then(m => m.RecipeStorePage)
      },
      {
        path: 'recipe-step-store',
        loadComponent: () => import('./Pages/YuChef/Recipes/recipe-step-store/recipe-step-store.page').then(m => m.RecipeStepStorePage)
      },
      {
        path: 'recipe-ingredient-store',
        loadComponent: () => import('./Pages/YuChef/Recipes/recipe-ingredient-store/recipe-ingredient-store.page').then(m => m.RecipeIngredientStorePage)
      },
      {
        path: 'recipe-result-store',
        loadComponent: () => import('./Pages/YuChef/Recipes/recipe-result-store/recipe-result-store.page').then(m => m.RecipeResultStorePage)
      },
      {
        path: 'labeled-store',
        loadComponent: () => import('./Pages/YuChef/Labeled/labeled-store/labeled-store.page').then(m => m.LabeledStorePage)
      },
      {
        path: 'labeled-history',
        loadComponent: () => import('./Pages/YuChef/Labeled/labeled-history/labeled-history.page').then(m => m.LabeledHistoryPage)
      },
      {
        path: 'labeled-add-info',
        loadComponent: () => import('./Pages/YuChef/Labeled/labeled-add-info/labeled-add-info.page').then(m => m.LabeledAddInfoPage)
      },
      {
        path: 'mise-en-place-options',
        loadComponent: () => import('./Pages/YuChef/Mise-en-place/mise-en-place-options/mise-en-place-options.page').then(m => m.MiseEnPlaceOptionsPage)
      },
      {
        path: 'production-elaboration-store',
        loadComponent: () => import('./Pages/YuChef/Mise-en-place/production-elaboration-store/production-elaboration-store.page').then(m => m.ProductionElaborationStorePage)
      },
      {
        path: 'production-recipe-store',
        loadComponent: () => import('./Pages/YuChef/Mise-en-place/production-recipe-store/production-recipe-store.page').then(m => m.ProductionRecipeStorePage)
      },
      {
        path: 'min-max-store',
        loadComponent: () => import('./Pages/Warehouse/Stocks/min-max-store/min-max-store.page').then(m => m.MinMaxStorePage)
      },
      {
        path: 'task/:id',
        loadComponent: () => import('./Pages/Tasks/General/task-detail/task-detail.page').then(m => m.TaskDetailPage)
      },
      {
        path: 'task-store',
        loadComponent: () => import('./Pages/Tasks/General/task-store/task-store.page').then(m => m.TaskStorePage)
      },
      {
        path: 'task-options',
        loadComponent: () => import('./Pages/Tasks/General/task-options/task-options.page').then(m => m.TaskOptionsPage)
      },
      {
        path: 'image-reviewer',
        loadComponent: () => import('./Pages/Tasks/Image-reviewer/image-reviewer-list/image-reviewer-list.page').then(m => m.ImageReviewerListPage)
      },
      {
        path: 'image-reviewer-options',
        loadComponent: () => import('./Pages/Tasks/Image-reviewer/image-reviewer-options/image-reviewer-options.page').then(m => m.ImageReviewerOptionsPage)
      },
      {
        path: 'model-store',
        loadComponent: () => import('./Pages/Tasks/Checklists/Models/model-store/model-store.page').then(m => m.ModelStorePage)
      },
      {
        path: 'model/:id',
        loadComponent: () => import('./Pages/Tasks/Checklists/Models/model-detail/model-detail.page').then(m => m.ModelDetailPage)
      },
      {
        path: 'field-store',
        loadComponent: () => import('./Pages/Tasks/Checklists/Models/field-store/field-store.page').then(m => m.FieldStorePage)
      },
      {
        path: 'schedules-checklist-store',
        loadComponent: () => import('./Pages/Tasks/Checklists/Schedules/schedules-checklist-store/schedules-checklist-store.page').then(m => m.SchedulesChecklistStorePage)
      },
      {
        path: 'schedules-appcc-store',
        loadComponent: () => import('./Pages/Tasks/Appccs/Schedules/schedules-appcc-store/schedules-appcc-store.page').then(m => m.SchedulesAppccStorePage)
      },
      {
        path: 'machine-appcc-store',
        loadComponent: () => import('./Pages/Tasks/Appccs/Checkpoints/machine-appcc-store/machine-appcc-store.page').then(m => m.MachineAppccStorePage)
      },
      {
        path: 'product-appcc-store',
        loadComponent: () => import('./Pages/Tasks/Appccs/Checkpoints/product-appcc-store/product-appcc-store.page').then(m => m.ProductAppccStorePage)
      },
      {
        path: 'provider-appcc-store',
        loadComponent: () => import('./Pages/Tasks/Appccs/Checkpoints/provider-appcc-store/provider-appcc-store.page').then(m => m.ProviderAppccStorePage)
      },
      {
        path: 'machine/:id',
        loadComponent: () => import('./Pages/Tasks/Appccs/Checkpoints/machine-detail/machine-detail.page').then(m => m.MachineDetailPage)
      },
      {
        path: 'wastages-store',
        loadComponent: () => import('./Pages/Warehouse/Wastages/wastages-store/wastages-store.page').then(m => m.WastagesStorePage)
      },
      {
        path: 'operation',
        children: [
          {
            path: 'reload/:id',
            loadComponent: () => import('./Pages/Warehouse/Operations/operation-reload/operation-reload.page').then(m => m.OperationReloadPage)
          },
          {
            path: 'inventory/:id',
            loadComponent: () => import('./Pages/Warehouse/Operations/operation-inventory/operation-inventory.page').then(m => m.OperationInventoryPage)
          },
          {
            path: 'revision/:id',
            loadComponent: () => import('./Pages/Warehouse/Operations/operation-revision/operation-revision.page').then(m => m.OperationRevisionPage)
          }
        ],
      },
      {
        path: 'operation-inventory-options',
        loadComponent: () => import('./Pages/Warehouse/Operations/operation-inventory-options/operation-inventory-options.page').then(m => m.OperationInventoryOptionsPage)
      },
      {
        path: 'product-providers-formats',
        loadComponent: () => import('./Pages/Shared/product-providers-formats/product-providers-formats.page').then(m => m.ProductProvidersFormatsPage)
      },
      {
        path: 'transfers-options',
        loadComponent: () => import('./Pages/Warehouse/Transfers/transfers-options/transfers-options.page').then(m => m.TransfersOptionsPage)
      },
      {
        path: 'transfer-store',
        loadComponent: () => import('./Pages/Warehouse/Transfers/transfer-store/transfer-store.page').then(m => m.TransferStorePage)
      },
      {
        path: 'transfer/:id',
        loadComponent: () => import('./Pages/Warehouse/Transfers/transfer-detail/transfer-detail.page').then(m => m.TransferDetailPage)
      },
      {
        path: 'transfer-product-store',
        loadComponent: () => import('./Pages/Warehouse/Transfers/transfer-product-store/transfer-product-store.page').then(m => m.TransferProductStorePage)
      },
      {
        path: 'stocks-product-store',
        loadComponent: () => import('./Pages/Warehouse/Stocks/stocks-product-store/stocks-product-store.page').then(m => m.StocksProductStorePage)
      },
      {
        path: 'transfer-stock',
        loadComponent: () => import('./Pages/Warehouse/Transfers/transfer-stock/transfer-stock.page').then(m => m.TransferStockPage)
      },
      {
        path: 'inventory-stock',
        loadComponent: () => import('./Pages/Warehouse/Inventory/inventory-stock/inventory-stock.page').then(m => m.InventoryStockPage)
      },
      {
        path: 'stock-products-revision',
        loadComponent: () => import('./Pages/Warehouse/Stocks/stock-products-revision/stock-products-revision.page').then(m => m.StockProductsRevisionPage)
      },
      {
        path: 'send-order-email',
        loadComponent: () => import('./Pages/Purchases/Orders/send-order-email/send-order-email.page').then(m => m.SendOrderEmailPage)
      },
      {
        path: 'add-previous-order',
        loadComponent: () => import('./Pages/Purchases/Orders/add-previous-order/add-previous-order.page').then(m => m.AddPreviousOrderPage)
      },
      {
        path: 'add-products-order',
        loadComponent: () => import('./Pages/Purchases/Orders/add-products-order/add-products-order.page').then(m => m.AddProductsOrderPage)
      },
      {
        path: 'select-pendents-products',
        loadComponent: () => import('./Pages/Purchases/Delivery-notes/select-pendents-products/select-pendents-products.page').then(m => m.SelectPendentsProductsPage)
      },
      {
        path: 'add-products-delivery-note',
        loadComponent: () => import('./Pages/Purchases/Delivery-notes/add-products-delivery-note/add-products-delivery-note.page').then(m => m.AddProductsDeliveryNotePage)
      },
      {
        path: 'sign-delivery-note',
        loadComponent: () => import('./Pages/Purchases/Delivery-notes/sign-delivery-note/sign-delivery-note.page').then(m => m.SignDeliveryNotePage)
      },
      {
        path: 'edit-product',
        loadComponent: () => import('./Pages/Purchases/Delivery-notes/edit-product/edit-product.page').then(m => m.EditProductPage)
      },
      {
        path: 'multisession-list',
        loadComponent: () => import('./Pages/Multisession/multisession-list/multisession-list.page').then(m => m.MultisessionListPage)
      },
      {
        path: 'keyboard-modal',
        loadComponent: () => import('./Pages/Shared/keyboard-modal/keyboard-modal.page').then(m => m.KeyboardModalPage)
      },
      {
        path: 'purchases-reports-options',
        loadComponent: () => import('./Pages/Reports/Purchases/Shared/purchases-reports-options/purchases-reports-options.page').then(m => m.PurchasesReportsOptionsPage)
      },
      {
        path: 'tasks-reports-options',
        loadComponent: () => import('./Pages/Reports/Tasks/Shared/tasks-reports-options/tasks-reports-options.page').then(m => m.TasksReportsOptionsPage)
      },
      {
        path: 'ranking-list',
        loadComponent: () => import('./Pages/Reports/Tasks/Shared/ranking-list/ranking-list.page').then(m => m.RankingListPage)
      },
      {
        path: 'task-detail-report',
        loadComponent: () => import('./Pages/Reports/Tasks/Shared/task-detail-report/task-detail-report.page').then(m => m.TaskDetailReportPage)
      },
      {
        path: 'sign-clock-in',
        loadComponent: () => import('./Pages/Rrhh/Clock-in/sign-clock-in/sign-clock-in.page').then(m => m.SignClockInPage)
      },
      {
        path: 'bottle-meter',
        loadComponent: () => import('./Pages/Shared/bottle-meter/bottle-meter.page').then(m => m.BottleMeterPage)
      },
      {
        path: 'widgets-store',
        loadComponent: () => import('./Pages/Widgets/widgets-store/widgets-store.page').then(m => m.WidgetsStorePage)
      },
      {
        path: 'communication-store',
        loadComponent: () => import('./Pages/Communication/communication-store/communication-store.page').then(m => m.CommunicationStorePage)
      },
      {
        path: 'communication/:id',
        loadComponent: () => import('./Pages/Communication/communication-detail/communication-detail.page').then(m => m.CommunicationDetailPage)
      },
      {
        path: 'communication-options',
        loadComponent: () => import('./Pages/Communication/communication-options/communication-options.page').then(m => m.CommunicationOptionsPage)
      },
      {
        path: 'breakdown-budget-store',
        loadComponent: () => import('./Pages/Communication/breakdown-budget-store/breakdown-budget-store.page').then(m => m.BreakdownBudgetStorePage)
      },
      {
        path: 'suggested-products-list',
        loadComponent: () => import('./Pages/Purchases/Products/suggested-products-list/suggested-products-list.page').then(m => m.SuggestedProductsListPage)
      },
      {
        path: 'assistant-chat',
        loadComponent: () => import('./Pages/Assistant/assistant-chat/assistant-chat.page').then(m => m.AssistantChatPage)
      },
      {
        path: 'widgets-filters',
        loadComponent: () => import('./Pages/Widgets/widgets-filters/widgets-filters.page').then(m => m.WidgetsFiltersPage)
      },
      {
        path: 'inventory-stock-options',
        loadComponent: () => import('./Pages/Warehouse/Inventory/inventory-stock-options/inventory-stock-options.page').then(m => m.InventoryStockOptionsPage)
      },
      {
        path: 'videos-viewer',
        loadComponent: () => import('./Pages/Shared/videos-viewer/videos-viewer.page').then(m => m.VideosViewerPage)
      },
      {
        path: 'event/:id',
        loadComponent: () => import('./Pages/Events/event-detail/event-detail.page').then(m => m.EventDetailPage)
      },
      {
        path: 'inventory-event/:id',
        loadComponent: () => import('./Pages/Events/inventory-event/inventory-event.page').then(m => m.InventoryEventPage)
      },
      {
        path: 'clock-in-detail-report',
        loadComponent: () => import('./Pages/Reports/Rrhh/Clock-in/clock-in-detail-report/clock-in-detail-report.page').then(m => m.ClockInDetailReportPage)
      },
      {
        path: 'share-clock-in-report',
        loadComponent: () => import('./Pages/Reports/Rrhh/Clock-in/share-clock-in-report/share-clock-in-report.page').then(m => m.ShareClockInReportPage)
      },
      {
        path: 'print-label-options',
        loadComponent: () => import('./Pages/Shared/print-label-options/print-label-options.page').then(m => m.PrintLabelOptionsPage)
      },
      {
        path: 'delivery-note-review/:id',
        loadComponent: () => import('./Pages/Documents-review/delivery-note-review/delivery-note-review.page').then(m => m.DeliveryNoteReviewPage)
      },
      {
        path: 'expense-review',
        loadComponent: () => import('./Pages/Documents-review/expense-review/expense-review.page').then(m => m.ExpenseReviewPage)
      },
      {
        path: 'payroll-review',
        loadComponent: () => import('./Pages/Documents-review/payroll-review/payroll-review.page').then(m => m.PayrollReviewPage)
      },
      {
        path: 'unclassified-review',
        loadComponent: () => import('./Pages/Documents-review/unclassified-review/unclassified-review.page').then(m => m.UnclassifiedReviewPage)
      }
    ]
  },
  {
    path: 'login',
    loadComponent: () => import('./Pages/Auth/login/login.page').then(m => m.LoginPage)
  },
  {
    path: 'register',
    loadComponent: () => import('./Pages/Auth/register/register.page').then(m => m.RegisterPage)
  },
  {
    path: 'forget-pass',
    loadComponent: () => import('./Pages/Auth/forget-pass/forget-pass.page').then(m => m.ForgetPassPage)
  },
  {
    path: 'visor',
    loadComponent: () => import('./Pages/Auth/visor/visor.page').then(m => m.VisorPage)
  }
];

